<!--
 * @Author: DQL
 * @Date: 2022-04-28 11:18:16
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:31:35
 * @Description: file content
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        kTableList
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />

        <k-button
          btn-text="重置"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />

        <k-button
          btn-text="导出"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :rules="filterParamsRules"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="业务流程名称"
                prop="infoName"
              >
                <el-input
                  v-model.trim="filterParams.infoName"
                  class="c-form__input"
                  placeholder="请输入业务流程名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="任务状态"
                prop="status"
              >
                <el-select
                  v-model="filterParams.status"
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择任务状态"
                >
                  <el-option
                    :value="null"
                    label="全部"
                  />
                  <el-option
                    v-for="item in statusOption"
                    :key="item.id"
                    :value="item.id"
                    :label="item.text"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="执行时间起止"
                prop="zxsjQZ"
              >
                <hm-date-range
                  ref="dateRange"
                  v-model="filterParams.zxsjQZ"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #deptName="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'robotWorkerLog', params: { logId: scope.row.id } })"
              >
                {{ scope.row.deptName }}
              </el-link>
            </template>
            <template
              #taskStatus="scope"
            >
              <span
                :class="{
                  'u-text-success' : scope.row.taskStatus==='600000',
                  'u-text-danger' : scope.row.taskStatus==='600099',
                  'u-text-primary' : scope.row.taskStatus!=='600000' && scope.row.taskStatus!=='600099'
                }"
              >
                {{ scope.row.taskStatusName }}
              </span>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  btn-text="编辑"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'robotWorkerLog', params: { logId: scope.row.id } })"
                />

                <k-button
                  btn-text="删除"
                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { kTableListService } from './kTableList.service.js';

export default {
  name: 'KTableList',
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        infoName: null, // 业务流程名称
        schedulingId: null, // 调度ID
        status: null, // 状态
        zxsjq: null, // 执行时间起
        zxsjz: null, // 执行时间止
        zxsjQZ: [null, null]
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        zxsjQZ: [this.$HMValidator.dateRange('开始时间')]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'deptName', slotName: 'deptName', label: '税务机关', align: 'left', minWidth: '120', type: 'text' },
        { key: 'infoCode', label: '业务流程编码', align: 'left', minWidth: '120', type: 'text' },
        { key: 'infoName', label: '业务流程名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'description', label: '业务流程描述', align: 'left', minWidth: '220', type: 'text' },
        { key: 'startTime', label: '任务开始时间', align: 'center', width: '130', type: 'dateTime' },
        { key: 'endTime', label: '任务结束时间', align: 'center', width: '130', type: 'dateTime' },
        { key: 'zxhs', label: '执行耗时', align: 'right', width: '130', type: 'text' },
        { key: 'taskStatus', slotName: 'taskStatus', label: '任务状态', align: 'left', width: '120', type: 'text' }
      ],
      /* 表格列配置End */

      statusOption: [
        { id: '1', text: '1' }
      ]

    };
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      [this.trueFilterParams.zxsjq, this.trueFilterParams.zxsjz] = this.trueFilterParams.zxsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      kTableListService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此任务：${_row.infoName}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        kTableListService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      kTableListService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
